




























import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { TransactionType, TypeComponentNoti } from "@/enums/enums";
import { OnlineViewModel } from "@/model/document/documentModel";
import { JournalOnlineViewModel } from "@/model/document/journalDocumentModal";

const StoreDocument = namespace("Document");
const StoreAlert = namespace("Alert");
@Component
export default class ModalViewPassCode extends Vue {
  @Prop({ default: "" }) documentName!: string;
  @Prop({ default: "" }) transactionNumber!: string;
  @Prop({ default: false }) isDocumentNameShort!: boolean;

  private showModal = true;

  @StoreDocument.Getter
  private getDocumentDetail!: OnlineViewModel | JournalOnlineViewModel | null;

  @StoreAlert.Action
  private SetAlertMessage!: (input: any) => void;

  @Watch("showModal")
  showModalChanged() {
    if (!this.showModal) {
      this.HideModal();
    }
  }

  public HideModal() {
    this.$emit("update:showModal", false);
  }
  public CopyPassCode() {
    if (this.getDocumentDetail) {
      this.$copyText(this.getDocumentDetail.credential.passCode);
    }
    this.SetAlertMessage({
      alertMessage: this.$t("Alert_Copy_Passcode_Success", {
        name: (this.isDocumentNameShort ? " " : "") + this.documentName,
        number: this.transactionNumber,
      }),
      typeMessage: TypeComponentNoti.Success,
    });
  }
}
